export default __webpack_public_path__ + "fonts/proximanova-semibold.woff2";